import VueCookies from 'vue-cookies'

const TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'
const EXPIRE_TOKEN_KEY = 'expiryTokenDate'
const TOKEN_TYPE_KEY = 'tokenType'

const BASE_DOMAIN = `${__config.base_domain}`
const STAGE = !__stage ? '' : __stage

/**
 * Manage the how Access Tokens are being stored and retrieved from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
 **/
const TokenService = {

  getExpireTokenDate () {
    return VueCookies.get(`${STAGE}_${EXPIRE_TOKEN_KEY}`)
  },

  setExpireTokenDate (expireDate) {
    VueCookies.set(`${STAGE}_${EXPIRE_TOKEN_KEY}`, expireDate, null, null, __stage === 'local' ? null : `.${BASE_DOMAIN}`, __stage !== 'local')
  },

  removeExpireTokenDate () {
    VueCookies.remove(`${STAGE}_${EXPIRE_TOKEN_KEY}`, '/', __stage === 'local' ? null : `.${BASE_DOMAIN}`)
  },

  getToken () {
    return VueCookies.get(`${STAGE}_${TOKEN_KEY}`)
  },

  setToken (accessToken) {
    VueCookies.set(`${STAGE}_${TOKEN_KEY}`, accessToken, null, null, __stage === 'local' ? null : `.${BASE_DOMAIN}`, __stage !== 'local')
  },

  removeToken () {
    VueCookies.remove(`${STAGE}_${TOKEN_KEY}`, '/', __stage === 'local' ? null : `.${BASE_DOMAIN}`)
  },

  getTokenType () {
    return VueCookies.get(`${STAGE}_${TOKEN_TYPE_KEY}`)
  },

  setTokenType (type) {
    VueCookies.set(`${STAGE}_${TOKEN_TYPE_KEY}`, type, null, null, __stage === 'local' ? null : `.${BASE_DOMAIN}`, __stage !== 'local')
  },

  removeTokenType () {
    VueCookies.remove(`${STAGE}_${TOKEN_TYPE_KEY}`, '/', __stage === 'local' ? null : `.${BASE_DOMAIN}`)
  },

  getRefreshToken () {
    return VueCookies.get(`${STAGE}_${REFRESH_TOKEN_KEY}`)
  },

  setRefreshToken (refreshToken) {
    VueCookies.set(`${STAGE}_${REFRESH_TOKEN_KEY}`, refreshToken, null, null, __stage === 'local' ? null : `.${BASE_DOMAIN}`, __stage !== 'local')
  },

  removeRefreshToken () {
    VueCookies.remove(`${STAGE}_${REFRESH_TOKEN_KEY}`, '/', __stage === 'local' ? null : `.${BASE_DOMAIN}`)
  }

}

export { TokenService }
